export class MigrateReqModal {
    className: string;
    subject: string;
    chapter: string;
    baseLanguage: string;
    requestedLanguages: string[];
    constructor(className: string, subject: string, chapter: string,baseLanguage: string, requestedLanguages: string[]) {
        this.className = className;
        this.subject = subject;
        this.chapter = chapter;
        this.baseLanguage = baseLanguage;
        this.requestedLanguages = requestedLanguages;
    }
}